import React, { createContext, useContext, useEffect, useState } from 'react';

const OfflineContext = createContext();

export const OfflineProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [storageInfo, setStorageInfo] = useState({ items: 0, sizeInMB: 0 });

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    const updateStorageInfo = () => {
      let items = 0;
      let sizeInMB = 0;

      for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
          items++;
          sizeInMB += localStorage[key].length / (1024 * 1024);
        }
      }

      setStorageInfo({ items, sizeInMB: sizeInMB.toFixed(2) });
    };

    updateStorageInfo();
  }, []);

  return (
    <OfflineContext.Provider value={{ isOnline, storageInfo }}>
      {children}
    </OfflineContext.Provider>
  );
};

export const useOffline = () => {
  const context = useContext(OfflineContext);
  if (!context) {
    throw new Error('useOffline must be used within OfflineProvider');
  }
  return context;
};